import React from "react";
import "./Footer.css";
import { Link, useLocation } from "react-router-dom";
import { greeting, socialMediaLinks } from "../../portfolio.js";

export default function Footer() {
  const email = socialMediaLinks.find((s) => s.name === "Gmail");
  const { pathname } = useLocation();
  // the contact page already has the form, so skip the call-to-action there
  const showCta = !pathname.startsWith("/contact");
  return (
    <footer className="footer-div">
      {showCta && (
      <div className="cta">
        <span className="section-kicker">Contact</span>
        <h2 className="cta-title">Have a product in mind? Let's build it.</h2>
        <p className="cta-sub">
          Open to full-stack, mobile and cloud engagements. Tell me about the
          problem and I'll reply with a plan.
        </p>
        <div className="cta-actions">
          <Link to="/contact" className="btn btn-primary">
            Start a conversation
          </Link>
          {email && (
            <a className="btn btn-ghost" href={email.link}>
              Email me
            </a>
          )}
        </div>
      </div>
      )}
      <div className="footer-bar">
        <span>
          © {new Date().getFullYear()} {greeting.title}. All rights reserved.
        </span>
        <span className="footer-links">
          {socialMediaLinks
            .filter((s) => ["Github", "LinkedIn"].includes(s.name))
            .map((s) => (
              <a key={s.name} href={s.link} target="_blank" rel="noopener noreferrer">
                {s.name}
              </a>
            ))}
        </span>
      </div>
    </footer>
  );
}
